import { TextField, TextFieldProps } from "@mui/material";

interface GKTextAreaProps {
  inputLabel?: string;
  helperText?: string;
}

function GKTextArea(props: GKTextAreaProps & TextFieldProps) {
  const { inputLabel } = props;
  return (
    <TextField
      {...props}
      placeholder={inputLabel || "enter"}
      label={inputLabel}
      fullWidth
      rows={4}
      multiline
    />
  );
}

export default GKTextArea;
